import { useEffect, useMemo, useState, useSyncExternalStore } from "react";
import AttachmentController from "./AttachmentController";

const EMPTY_FILES = [];

export default function useAttachments(
  client,
  sessionId,
  historical = EMPTY_FILES,
) {
  const controller = useMemo(() => new AttachmentController(client), [client]);
  const [, tick] = useState(0);
  useEffect(() => {
    if (!client) return;
    const timer = setInterval(() => tick((value) => value + 1), 1000);
    return () => clearInterval(timer);
  }, [client]);
  const state = useSyncExternalStore(
    controller.subscribe,
    controller.getSnapshot,
  );
  useEffect(() => {
    controller.open(sessionId, historical);
    return () => controller.close();
  }, [controller, sessionId, historical]);
  return {
    controller,
    sessionId,
    ...state,
  };
}
